module.exports = __webpack_public_path__ + "img/images.fd1fb26d.svg";